import { render, staticRenderFns } from "./AmendmentMessagesDetails.vue?vue&type=template&id=5f8c75bc&scoped=true&"
import script from "./AmendmentMessagesDetails.vue?vue&type=script&lang=js&"
export * from "./AmendmentMessagesDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8c75bc",
  null
  
)

export default component.exports